module.exports = __webpack_public_path__ + "img/7 llamar.6c6cd8cf.jpg";